import _ from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { HoverBoxSelectorCSSVars, HoverBoxCss } from '@wix/thunderbolt-components-native'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import { getContainerStyle } from '../../core/mappers/MediaContainer/MediaContainer.utils'

export const designCss = withCompInfo<HoverBoxSelectorCSSVars, any>()(
	[
		'compId',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
	],
	({
		compId,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
	}) => {
		const backgroundMedia = compDesign?.background || {}
		const fillLayersCss = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		const containerStyle = getContainerStyle(compDesign)
		const rootCss = _.mapKeys(containerStyle, (__, prop) => `--hover-box-${prop}`) as HoverBoxSelectorCSSVars
		const mergedCss = { ...fillLayersCss, ...rootCss } as HoverBoxCss

		return mergedCss
	}
)
